import {NgModule} from '@angular/core';
import {GalleryModalComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import {ButtonComponentModule} from '../../ui/button/item.module';
import {ModalHeaderComponentModule} from '../../ui/modal-header/item.module';
import {DirectivesModule} from '../../../core/directives/directives.module';
import {IconComponentModule} from '../../ui/icon/item.module';

@NgModule({
    imports: [
        IonicModule,
        NgStyle,
        NgClass,
        NgIf,
        ButtonComponentModule,
        ModalHeaderComponentModule,
        DirectivesModule,
        IconComponentModule,
        NgForOf
    ],
  exports: [
    GalleryModalComponent
  ],
  declarations: [GalleryModalComponent],
  providers: [],
})
export class GalleryModalComponentModule {
}
